export interface PalleteProps {
  background: string;
  text?: string;
  buttonBg?: string;
  buttonText?: string;
  graphLine?: string;
  border?: string;
  disabledBg?: string;
  disabledText?: string;
  inactiveOrCancelButtonBg?: string;
  inactiveOrCancelButtonText?: string;
  activeBg?: string;
  activeText?: string;
  iconCircle?: string;
  fontFamily?: string;
}

export const Palette: { [key: string]: PalleteProps } = {
  body: {
    background: '#e5e5e5',
  },
  default: {
    background: '#e5e5e5',
    text: '#113833',
    buttonBg: '#143c34',
    inactiveOrCancelButtonBg: '#ffffff',
    buttonText: '#ffffff',
    inactiveOrCancelButtonText: '#143c34',
    graphLine: '#1E7F6C',
    border: '#888888',
    disabledBg: '#E5E5E5', // light grey
    disabledText: '#888888',
    activeBg: '#c8d1cc',
    activeText: '#113833',
    iconCircle: '#dddddd',
  },
  tone1: {
    background: '#FFFFFF',
    text: '#143c34',
    buttonBg: '#c2d4bd',
    inactiveOrCancelButtonBg: '#ffffff',
    buttonText: '#123833',
    inactiveOrCancelButtonText: '#123833',
    graphLine: '#c2d4bd',
    border: '#123833',
    disabledBg: '#e5e5e5',
    disabledText: '#a1a1a1',
    activeBg: '#dbe7df',
    activeText: '#143c34',
    iconCircle: '#e1e8e4',
  },
  tone2: {
    background: '#EBEEEA',
    text: '#123833',
    buttonBg: '#d0dcc7',
    inactiveOrCancelButtonBg: '#ffffff',
    buttonText: '#ffffff',
    inactiveOrCancelButtonText: '#123833',
    graphLine: '#adc9a8',
    border: '#a7bda0',
    disabledBg: '#d2dfca',
    disabledText: '#7e9380',
    activeBg: '#b3c5aa',
    activeText: '#123833',
    iconCircle: '#d0dcc7',
  },
  tone3: {
    background: '#c2d4bd',
    text: '#123833',
    buttonBg: '#bed4b7',
    inactiveOrCancelButtonBg: '#ffffff',
    buttonText: '#ffffff',
    inactiveOrCancelButtonText: '#123833',
    graphLine: '#adc9a8',
    border: '#9eb89a',
    disabledBg: '#a8c3a5',
    disabledText: '#6c7e6b',
    activeBg: '#94b293',
    activeText: '#123833',
    iconCircle: '#bed4b7',
  },
  tone4: {
    background: '#123833',
    text: '#ffffff',
    buttonBg: '#ccd8cb',
    inactiveOrCancelButtonBg: '#123833',
    buttonText: '#123833',
    inactiveOrCancelButtonText: '#abc9a8',
    graphLine: '#0e2a24',
    border: '#4a6854',
    disabledBg: '#4a6854',
    disabledText: '#aabdad',
    activeBg: '#1a3f39',
    activeText: '#ffffff',
    iconCircle: '#ccd8cb',
  },
  tone5: {
    background: '#0e2a24',
    text: '#ffffff',
    buttonBg: '#d9e1da',
    inactiveOrCancelButtonBg: '#123833',
    buttonText: '#123833',
    inactiveOrCancelButtonText: '#abc9a8',
    graphLine: '#66bb6a',
    border: '#2e473e',
    disabledBg: '#3e544c',
    disabledText: '#859990',
    activeBg: '#1b3d36',
    activeText: '#ffffff',
    iconCircle: '#d9e1da',
  },
  active: {
    background: '#003366',
    text: '#ffffff',
    buttonBg: '#1a4d80',
    inactiveOrCancelButtonBg: '#ffffff',
    buttonText: '#ffffff',
    inactiveOrCancelButtonText: '#1a4d80',
    graphLine: '#6699cc',
    border: '#0055aa',
    disabledBg: '#e0eaf6',
    disabledText: '#5c7aa3',
  },
  danger: {
    background: '#fbeaea',
    text: '#5c1a1a',
    buttonBg: '#a73232',
    buttonText: '#ffffff',
    inactiveOrCancelButtonBg: '#ffffff',
    inactiveOrCancelButtonText: '#a73232',
    graphLine: '#e57373',
    border: '#e0b4b4',
    disabledBg: '#f2cccc',
    disabledText: '#a37b7b',
    activeBg: '#e69a9a',
    activeText: '#5c1a1a',
    iconCircle: '#f4d0d0',
  },
  warning: {
    background: '#fff8e1',
    text: '#5c3d00',
    buttonBg: '#f9a825',
    buttonText: '#ffffff',
    inactiveOrCancelButtonBg: '#ffffff',
    inactiveOrCancelButtonText: '#f9a825',
    graphLine: '#fdd835',
    border: '#ffecb3',
    disabledBg: '#fff3cd',
    disabledText: '#a68d60',
    activeBg: '#ffe28a',
    activeText: '#5c3d00',
    iconCircle: '#fff1ba',
  },
};
